export const ExtendedFooterTabs = ({ tabs, currentTab, setTab }) => {
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <div className="border-b border-slate-100">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab, index) => (
          <a
            key={tab.name}
            name={`#tab-${index}`}
            className={classNames(
              index === currentTab
                ? 'border-primary-800 text-primary-800'
                : 'border-transparent text-slate-500 hover:border-slate-700 hover:text-slate-700',
              'whitespace-nowrap border-b-2 sm:pb-4 text-base leading-normal cursor-pointer'
            )}
            aria-current={index === currentTab ? 'page' : undefined}
            onClick={() => setTab(index)}
          >
            {tab.name}
          </a>
        ))}
      </nav>
    </div>
  );
};
